import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "src/components/Footer";

const MainWrapper = styled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        background: ${theme.palette.background.default};

        @media (min-width: ${theme.breakpoints.values.lg}px) {
            padding-left: ${theme.sidebar.width};
        }
`
);

const MainContent = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
        background: ${theme.palette.background.default};
        display: flex;
        flex-direction: column;
`
);

const ContentArea = styled(Box)(
  () => `
        flex: 1 0 auto;
`
);

// Footer lives on the layout, not on every page. Page files
// should no longer import Footer directly.
const SidebarLayout = () => {
  return (
    <>
      <Sidebar />
      <MainWrapper>
        <Header />
        <MainContent>
          <ContentArea>
            <Outlet />
          </ContentArea>
          <Footer />
        </MainContent>
      </MainWrapper>
    </>
  );
};

export default SidebarLayout;
